import InternalControlsDND from './InternalControlsDND';

export default InternalControlsDND;
